<template>
    <div class="p-pt-1 p-ai-center p-grid p-jc-center">
        <div
                class=" p-col  "
        >
            <div class="p-inputgroup">
                <Button
                        v-tooltip.top="'הכיתה הקודמת'"
                        @click="navigateGrades(false)"
                        icon="pi  pi-angle-up"
                        class="
                    button-grade-back
                    p-inputgroup-addon
                    plus
                    p-button-secondary p-inputgroup-addon
                  "
                ></Button>

                <Dropdown
                        style="text-align: center"
                        filterPlaceholder=" חפש לפי כיתה"
                        emptyFilterMessage=" לא נמצא שם כיתה תואם"
                        :filter="true"
                        class=""
                        optionLabel="hebrewName"
                        v-model="selectedGrade"
                        :options="gradeOptionsFilter"
                        placeholder="בחר כיתה"
                        data-key="id"
                        @input="updateGrade"
                >
                    <template #value="slotProps">
                        <div v-if="slotProps.value">
                            <span>{{ slotProps.value.hebrewName }}</span>
                        </div>
                        <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                    </template>
                    <template #option="slotProps">
                        <span>{{ slotProps.option.hebrewName }}</span>
                    </template>
                </Dropdown>

                <Button
                        v-tooltip.top="'הכיתה הבאה'"
                        @click="navigateGrades(true)"
                        icon="pi  pi-angle-down"
                        class="plus p-button-secondary p-inputgroup-addon"
                ></Button>
            </div>
        </div>
        <div
                class=" p-col  "
        >
            <Dropdown
                    optionLabel="displayName"
                    style="text-align: center; width:100%"
                    v-model="selectedReportName"
                    :options="reportRanges"
                    data-key="id"
                    placeholder="בחר תעודה"
                    @input="updateReportName"
            >

            </Dropdown>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Vue from "vue";

export default {
    name: "SelectBar",
    data() {
        return {
            componentKey: 0,
            selectedGrade: null,
            selectedReportName: null,
        }
    },
    mounted() {
        this.selectedGrade = Vue.ls.get('menage_selectedGrade') || this.gradeOptionsFilter?.[0]
        this.selectedReportName = Vue.ls.get('menage_selectedReportName') || this.reportRanges[0]
        this.updateGrade()
        this.updateReportName()
    },

    watch: {
        selectedGrade(newValue, oldValue) {
            Vue.ls.set('grade_selectedGrade', newValue)
            Vue.ls.set('menage_selectedGrade', newValue);
            Vue.ls.set('pupil_selectedGrade', newValue);
        },
        selectedReportName(newValue, oldValue) {
            Vue.ls.set('pupil_selectedReportName', newValue);
            Vue.ls.set('menage_selectedReportName', newValue);
            Vue.ls.set('grade_selectedReportName', newValue);        }
    },
    methods: {
        updateGrade() {
            this.$emit("updateGrade", this.selectedGrade)
        },
        updateReportName() {
            this.$emit("updateReportName", this.selectedReportName)
        },
        navigateGrades(isAdd) {
            if (this.selectedGrade === null) return this.gradeOptionsFilter[0]
            const index = this.gradeOptionsFilter.findIndex(
                (grade) => grade.id === this.selectedGrade.id
            );
            this.selectedGrade =
                this.gradeOptionsFilter[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptionsFilter.length) %
                this.gradeOptionsFilter.length
                    ];
            this.updateGrade()
        },
    },
    computed: {
        gradeOptionsFilter(){
            return  this.user.role === 'ADMIN' ? this.gradeOptions : this.gradeOptions?.filter(grade => grade.id === this.user.grade)
        },
        ...mapState(["reportRanges","intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",
            "subjectTracing"]),
    }
}
</script>

<style scoped>

</style>